"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormatType = void 0;
var FormatType;
(function (FormatType) {
    FormatType["NUMBER"] = "number";
    FormatType["STRING"] = "string";
    FormatType["DATE"] = "date";
    FormatType["BOOLEAN"] = "boolean";
    FormatType["NULL"] = "null";
})(FormatType = exports.FormatType || (exports.FormatType = {}));
